import type { AppRoute } from 'src/routes/types';

import {
  Assignment,
  CorporateFare,
  DocumentScanner,
} from '@mui/icons-material';
import { t } from 'i18next';
import { lazy } from 'react';

const BusinessEntityListView = lazy(
  () => import('./views/BusinessEntityListView.tsx')
);
const FrameworkAgreementListView = lazy(
  () => import('./views/FrameworkAgreementListView.tsx')
);
const FrameworkAgreementEditView = lazy(
  () => import('./views/FrameworkAgreementEditView.tsx')
);
const FrameworkAgreementCreateView = lazy(
  () => import('./views/FrameworkAgreementCreateView.tsx')
);
const PlacementTypeListView = lazy(
  () => import('./views/PlacementTypeListView.tsx')
);

const businessEntityRoutePaths = {
  businessEntityListView: '/arrangement/business-entities',
} as const;

const businessEntityRoutes: AppRoute[] = [
  {
    element: <BusinessEntityListView />,
    enabled: true,
    menu: {
      group: 'management',
      icon: <CorporateFare />,
      title: () => t('arrangement:BUSINESS_ENTITIES'),
    },
    order: 3,
    path: businessEntityRoutePaths.businessEntityListView,
    permission: 'admin',
    scope: 'private',
  },
];

const placementTypeRoutePaths = {
  placementTypeListView: '/arrangement/placement-types',
} as const;

const placementTypeRoutes: AppRoute[] = [
  {
    element: <PlacementTypeListView />,
    enabled: true,
    menu: {
      group: 'management',
      icon: <Assignment />,
      title: () => t('arrangement:PLACEMENT_TYPES'),
    },
    order: 2,
    path: placementTypeRoutePaths.placementTypeListView,
    permission: 'admin',
    scope: 'private',
  },
];

const frameworkAgreementRoutePaths = {
  frameworkAgreementCreateView: '/arrangement/framework-agreements/create',
  frameworkAgreementEditView: '/arrangement/framework-agreements/:id',
  frameworkAgreementListView: '/arrangement/framework-agreements',
} as const;

const frameworkAgreementRoutes: AppRoute[] = [
  {
    element: <FrameworkAgreementListView />,
    enabled: true,
    menu: {
      group: 'management',
      icon: <DocumentScanner />,
      title: () => t('arrangement:FRAMEWORK_AGREEMENTS'),
    },
    order: 1,
    path: frameworkAgreementRoutePaths.frameworkAgreementListView,
    permission: 'all',
    scope: 'private',
  },
  {
    element: <FrameworkAgreementEditView />,
    enabled: true,
    path: frameworkAgreementRoutePaths.frameworkAgreementEditView,
    permission: 'all',
    scope: 'private',
  },
  {
    element: <FrameworkAgreementCreateView />,
    enabled: true,
    path: frameworkAgreementRoutePaths.frameworkAgreementCreateView,
    permission: 'admin',
    scope: 'private',
  },
];

export const arrangementRoutePaths = {
  ...businessEntityRoutePaths,
  ...frameworkAgreementRoutePaths,
  ...placementTypeRoutePaths,
} as const;

export const arrangementRoutes = [
  ...businessEntityRoutes,
  ...frameworkAgreementRoutes,
  ...placementTypeRoutes,
];
